import { Card, CardContent, Container, Grid, Typography } from "@mui/material";
import { observer } from "mobx-react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppContainer from "src/components/AppContainer";
import css from "./landing.module.scss";
import logo_land from "src/assets/logo_land.jpg";
import logo_sea from "src/assets/logo_sea.jpg";
import logo_air from "src/assets/logo_air.jpg";
import img_tm2 from "src/assets/tm2.jpg";
import img_tm3 from "src/assets/tm3.jpg";
import img_tm4 from "src/assets/tm4.jpg";
import img_tm5 from "src/assets/tm5.jpg";

const LandingPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isLoading, setLoading] = useState(true);

  const menus = [
    {
      name: t("landingPage.menuLand"),
      image: logo_land,
      disabled: false,
    },
    {
      name: t("landingPage.menuSea"),
      image: logo_sea,
      disabled: true,
    },
    {
      name: t("landingPage.menuAir"),
      image: logo_air,
      disabled: true,
    },
  ];

  const documents = [
    {
      name: t("TM2"),
      bgImage: img_tm2,
      path: "https://www.immigration.go.th/wp-content/uploads/simple-file-list2/form-download/1486546828049.pdf",
    },
    {
      name: t("TM3"),
      bgImage: img_tm3,
      path: "https://www.immigration.go.th/wp-content/uploads/simple-file-list2/form-download/1486547121721.pdf",
    },
    // {
    //   name: t("TM4"),
    //   bgImage: img_tm4,
    //   path: "",
    // },
    // {
    //   name: t("TM5"),
    //   bgImage: img_tm5,
    //   path: "",
    // },
  ];

  const download = (url, name) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <AppContainer
      showAppBar
      showLang
      showFooter
      isLoading={isLoading}
      title={t("landingPage.title")}
      className={css.appContainer}
    >
      <Container className={css.container}>
        <Typography variant="h5" className={css.topic}>
          {t("landingPage.register")}
        </Typography>

        <Grid container spacing={3} style={{ marginBottom: "48px" }}>
          {menus.map((menu, index) => (
            <Grid key={index} item xs={12}>
              <Card
                className={css.card}
                style={{ backgroundImage: `url(${menu.image})` }}
                onClick={() => (!menu.disabled ? navigate("/register") : null)}
              >
                <CardContent className={css.cardContent}>
                  <Typography variant="h3">{menu.name}</Typography>
                  {menu.disabled && (
                    <Typography variant="h6" className={css.disabled}>
                      ({t("landingPage.disabled")})
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Typography variant="h5" className={css.topic}>
          {t("landingPage.downloadDocument")}
        </Typography>

        <Grid container spacing={2}>
          {documents.map((document, index) => (
            <Grid
              key={index}
              item
              xs={12}
              md={6}
              onClick={() => download(document.path, document.name)}
            >
              <Card
                className={css.card}
                style={{
                  backgroundImage: `url(${document.bgImage})`,
                  height: "150px",
                }}
              >
                <CardContent className={css.cardContent}>
                  <Typography variant="h3">{document.name}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </AppContainer>
  );
};
export default observer(LandingPage);
